<template>
  <component :id="`badge_${module}`" />
  <img :src="`/images/results/${module_code}_${rank}.svg`">
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  position: {
    type: Number,
    required: true,
    validator(value) {
      return [1, 2, 3].includes(value);
    },
  },
  module: {
    type: String,
    required: true,
  },
});

const module_code = computed(() => {
  return props.module.split('_')[1].toLowerCase();
});

const rank = computed(() => {
  var rank_text;
  switch (props.position) {
    case 1:
    rank_text = "gold";
      break;
    case 2:
    rank_text = "silver";
      break;
    case 3:
    rank_text = "bronze";
      break;
  
    default:
      break;
  }
  return rank_text;
});
</script>
